export const PCP_PROVIDER_ANSWER = {
  N: 'N',
  Y: 'Y',
  U: 'U',
  S: 'S',
};

export const PCP_NOT_LISTED_VALUE = 'PCP_NOT_LISTED';



// WEBPACK FOOTER //
// ./src/constants/pcpAnswer.js